import { styled } from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";

export const TooltipValue = styled.p`
    margin: 0;
    ${setFontVariant("body2", colorsPalettes.carbon[500])}
`;
